import { useState, useRef, useEffect } from 'react';
import '../../styles/components/MultiSelect.scss';

const MultiSelect = ({ options, value, onChange, placeholder = 'Seleccionar...' }) => {
  const [open, setOpen]       = useState(false);
  const [search, setSearch]   = useState('');
  const containerRef          = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectedSet = new Set(value);

  const toggle = (id) => {
    onChange(selectedSet.has(id) ? value.filter(v => v !== id) : [...value, id]);
  };

  const remove = (e, id) => {
    e.stopPropagation();
    onChange(value.filter(v => v !== id));
  };

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );

  const labelOf = (id) => options.find(o => o.value === id)?.label ?? id;

  return (
    <div className={`ms${open ? ' ms--open' : ''}`} ref={containerRef}>
      <div className="ms__control" onClick={() => setOpen(o => !o)}>
        <div className="ms__tags">
          {value.length === 0 && (
            <span className="ms__placeholder">{placeholder}</span>
          )}
          {value.map(id => (
            <span key={id} className="ms__tag">
              <span className="ms__tag-label">{labelOf(id)}</span>
              <button type="button" className="ms__tag-remove" onClick={(e) => remove(e, id)}>×</button>
            </span>
          ))}
        </div>
        <span className="ms__arrow">▾</span>
      </div>

      {open && (
        <div className="ms__dropdown">
          <div className="ms__search-wrap">
            <input
              autoFocus
              className="ms__search"
              placeholder="Buscar..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              onClick={e => e.stopPropagation()}
            />
          </div>
          <ul className="ms__list">
            {filtered.length === 0 && (
              <li className="ms__empty">Sin resultados</li>
            )}
            {filtered.map(o => (
              <li
                key={o.value}
                className={`ms__option${selectedSet.has(o.value) ? ' ms__option--selected' : ''}${o.isGroup ? ' ms__option--group' : ''}`}
                onClick={() => !o.isGroup && toggle(o.value)}
              >
                {o.isGroup
                  ? o.label
                  : <>
                      <span className={`ms__check${selectedSet.has(o.value) ? ' ms__check--on' : ''}`}>✓</span>
                      {o.label}
                    </>
                }
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
